var _defs, _path, _path2, _path3, _path4, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack196({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.b,.c,.d{stroke:#fff;stroke-miterlimit:10;}.c,.d{stroke-width:0.5px;}.c{fill:url(#a);}.d{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 8,
    x2: 8.57,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 147.85,
    y1: -218.2,
    x2: 156.42,
    y2: -218.2,
    gradientTransform: "translate(-213.92 -144.13) rotate(90)",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.76,6.67l.6-2.87h2.07l-.07.33H10.68L10.49,5h1.64l-.07.33H10.42l-.21,1H12L12,6.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.12,6.67l1.37-1.45L12.68,3.8h.42l.37.65.17.3.11.23c.1-.13.25-.3.45-.52l.63-.66h.5L13.94,5.28l.79,1.39h-.42l-.46-.84a3.15,3.15,0,0,1-.16-.32,2.32,2.32,0,0,1-.26.3l-.8.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.32,11.47l.6-2.87h1.86l-.07.33H10.23L10,9.84h1.51l-.07.33H10l-.27,1.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.26,11.47,12.08,8.6h.39L12.54,10c0,.07,0,.25,0,.55v.37c.16-.33.27-.56.34-.69l.88-1.65h.39l.1,1.68c0,.19,0,.42,0,.69a2.28,2.28,0,0,1,.12-.3l.21-.45.82-1.62h.39l-1.46,2.87H14l-.09-1.74c0-.15,0-.33,0-.55-.08.19-.15.33-.2.43l-1,1.86Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.28,
    cy: 8,
    r: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 8,
    x2: 8.57,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 4.28,
    y1: 3.72,
    x2: 4.28,
    y2: 12.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack196);
export default __webpack_public_path__ + "static/media/Symbolpack_1_96.73d93adca0da150f85dcaf1b39e38dc0.svg";
export { ForwardRef as ReactComponent };